<cipo-dialog-header title="FROALA.placeholders.title" />
<mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="16px" class="cipo--height--full">
        <mat-form-field appearance="outline" fxFlex="none" class="cipo--width--full p-t-md">
            <mat-icon matPrefix aria-hidden="true">search</mat-icon>
            <input
                matInput
                [formControl]="searchControl"
                data-testid="froala-placeholders-search"
                [placeholder]="'FROALA.placeholders.searchLabel' | translate" />
        </mat-form-field>
        <cipo-paged-data-list
            fxFlex="grow"
            class="cipo--overflow--hidden"
            [tableColumns]="tableColumns"
            [tableData]="tableData()"
            [options]="tableOptions"
            (rowClicked)="onRowClicked($event)" />
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>{{ "actions.close" | translate }}</button>
</mat-dialog-actions>
